import { DurationInput } from "@/overlay/components/CommonParts/DurationInput";
import styles from "@/overlay/components/QuickAccessLabel/ControlComponents/Control.module.scss";
import { MmFabButton } from "@mm/zeus-react";
import debounce from "lodash/debounce";
import { Duration } from "luxon";
import React, { useMemo, useState } from "react";
import type { OffsetControlsProps } from "./OffsetControlType";

export function BasicOffsetControl({ offsetMinutes, onOffsetChange }: OffsetControlsProps) {
  const [offset, setOffset] = useState(Duration.fromObject({ minutes: offsetMinutes }));

  const debouncedChangeHandler = useMemo(() => debounce(onOffsetChange, 400), [onOffsetChange]);

  const saveOffset = (newTime: Duration) => {
    setOffset(newTime);
    const { minutes } = newTime.shiftTo("minutes").toObject();
    if (minutes !== undefined) {
      debouncedChangeHandler(minutes);
    }
  };

  return (
    <div className={styles.styleControlsBasic}>
      <div className={styles["font-size-controls"]}>
        <DurationInput
          minHours={-9000}
          maxHours={9000}
          duration={offset}
          onChange={(value) => saveOffset(value)}
          resetPosition={"left"}
        />
        <MmFabButton
          iconname="remove"
          onClick={() => saveOffset(offset.minus({ hour: 1 }))}
          rounded={true}
          size="xsmall"
        />
        <MmFabButton iconname="add" onClick={() => saveOffset(offset.plus({ hour: 1 }))} rounded={true} size="xsmall" />
      </div>
    </div>
  );
}
